import { render, staticRenderFns } from "./SpotSheet.vue?vue&type=template&id=8b12e44e&scoped=true&"
import script from "./SpotSheet.vue?vue&type=script&lang=js&"
export * from "./SpotSheet.vue?vue&type=script&lang=js&"
import style0 from "./SpotSheet.vue?vue&type=style&index=0&id=8b12e44e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b12e44e",
  null
  
)

export default component.exports